import { BREAK_POINTS, BREAK_POINTS_SIZES } from 'constants/uiConfig'
import { useState, useEffect } from 'react'

function useBreakpoint () {
  const [breakpoint, setBreakpoint] = useState('')

  useEffect(() => {
    const checkBreakpoint = () => {
      if (window.innerWidth <= BREAK_POINTS_SIZES.xs) setBreakpoint(BREAK_POINTS.xs)
      else if (window.innerWidth <= BREAK_POINTS_SIZES.sm) setBreakpoint(BREAK_POINTS.sm)
      else if (window.innerWidth <= BREAK_POINTS_SIZES.md) setBreakpoint(BREAK_POINTS.md)
      else if (window.innerWidth <= BREAK_POINTS_SIZES.lg) setBreakpoint(BREAK_POINTS.lg)
      else if (window.innerWidth <= BREAK_POINTS_SIZES.xlm) setBreakpoint(BREAK_POINTS.xlm)
      else setBreakpoint(BREAK_POINTS.xl)
    }

    checkBreakpoint() // Initial check
    window.addEventListener('resize', checkBreakpoint)

    return () => window.removeEventListener('resize', checkBreakpoint)
  }, [])

  return breakpoint
}

export default useBreakpoint
